export default "__VITE_ASSET__BQ1f_Cob__"